<template>
  <a-card v-if="cardFlag" :title="title" :size="cardSize">
    <template #extra><slot name="extra" /></template>
    <a-tree
      class="dol-tree"
      :tree-data="innerData"
      :field-names="fieldNames"
      :check-strictly="checkStrictly"
      :checked-keys="checkedKeys"
      @check="check"
      @select="select"
    >
      <template #title="data"><slot name="title" v-bind="data">{{data.name}}</slot></template>
    </a-tree>
  </a-card>
  <a-tree
    v-else
    class="dol-tree"
    :tree-data="innerData"
    :field-names="fieldNames"
    :check-strictly="checkStrictly"
    :checked-keys="checkedKeys"
    @check="check"
    @select="select"
  >
    <template #title="data"><slot name="title" v-bind="data">{{data.name}}</slot></template>
  </a-tree>
</template>

<script>
import requestMixins from '../common/requestMixins';

export default {
  name: "dol-tree",
  mixins: [requestMixins],
  emits: ['update:checkedKeys', 'select'],
  props: {
    checkStrictly: {type: Boolean, default: false},
    checkedKeys: {type: Array, default: () => []},

    pagination: {type: Boolean, default: false},
    method: {type: String, default: 'get'},
    fieldNames: {type: Object, default: () => ({title: 'name', key: '_id', children: 'children'})},

    cardFlag: {type: Boolean, default: false},
    title: {type: String, default: '树'},
    cardSize: {type: String, default: 'small'},
  },
  methods: {
    check(checkedKeys, {checked, checkedNodes, node, event}){
      if(this.checkStrictly){
        this.$emit('update:checkedKeys', checkedKeys.checked, {checked, checkedNodes, node, event});
      }else{
        this.$emit('update:checkedKeys', checkedKeys, {checked, checkedNodes, node, event});
      }
    },
    select(selectedKeys, {selected, selectedNodes, node, event}){
      this.$emit('select', selectedKeys, {selected, selectedNodes, node, event});
    },
  },
  created() {
    this.query();
  }
};
</script>

<style lang="scss">
.dol-tree {

}
</style>
